import styled from 'styled-components';

export const Container = styled.div`
  width: 30rem;
  height: 30rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
